import TYPES from '@/types';
import store from '@/vue-app/store';

// Application
import GetPersonQueryService
  from '@/modules/onboarding/person/application/queries/get-person-query-service';
import CreateOnBoardingInterviewCommand
  from '@/modules/onboarding/interviews/application/commands/create-on-boarding-interview-command';
import UpdateOnboardingStepCommand
  from '@/modules/onboarding/status/application/commands/update-onboarding-step-command';
import OnBoardingSearchCustomerEmailsQuery
  from '@/modules/onboarding/customer-email/application/queries/on-boarding-search-customer-emails-query';
import GetInternetStatusQuery
  from '@/modules/internet-status/application/queries/get-internet-status-query';
import { GetOnboardingStepQuery } from '@/modules/onboarding/status/application/queries';
import LogoutCommand from '@/modules/authentication/application/commands/logout-command';

// Domain
import { StepEntity } from '@/modules/onboarding/status/domain/entities';
import Inject from '@/modules/shared/domain/di/inject';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';

export default class ValidationProcessViewModel {
  @Inject(TYPES.GET_PERSON_QUERY_SERVICE)
  private readonly get_person_query!: GetPersonQueryService;

  @Inject(TYPES.CREATE_ON_BOARDING_INTERVIEW_COMMAND)
  private readonly create_on_boarding_interview_command!: CreateOnBoardingInterviewCommand;

  @Inject(TYPES.UPDATE_ONBOARDING_STEP_COMMAND)
  private readonly update_on_boarding_step_command!: UpdateOnboardingStepCommand;

  @Inject(TYPES.ON_BOARDING_SEARCH_CUSTOMER_EMAILS_QUERY)
  private readonly on_boarding_list_emails_query!: OnBoardingSearchCustomerEmailsQuery;

  @Inject(TYPES.GET_INTERNET_STATUS_QUERY)
  private readonly get_internet_status_query!: GetInternetStatusQuery;

  @Inject(TYPES.GET_ONBOARDING_STEP_QUERY)
  private readonly get_on_boarding_step_query!: GetOnboardingStepQuery;

  @Inject(TYPES.LOGOUT_COMMAND)
  readonly logout_command!: LogoutCommand;

  @Inject(TYPES.NOTIFIER)
  private readonly notifier!: MessageNotifier;

  BACKOFFICE_CUSTOMER_TRACKING = `${process.env.VUE_APP_BACKOFFICE_URL}/onboarding-asesores/customer-tracking`

  current_step: StepEntity = {
    id: '',
    current_step: '',
    payload: {},
  };

  has_error = false;

  modal_is_open = false;

  is_logged_as_promoter = false;

  get internet_status() {
    return this.get_internet_status_query.execute();
  }

  constructor() {
    this.showGoToSiteOnHeader();
    this.on_boarding_list_emails_query.execute();
  }

  initialize = async () => {
    await store.dispatch('layout/toggleGoToSiteOnHeader', false);
    this.unserializeToken();
    this.current_step = await this.get_on_boarding_step_query.execute('validation_process');
    this.setHasErrorAccordingToStepsData();
  }

  private setHasErrorAccordingToStepsData() {
    if (!this.current_step.payload.is_valid && !this.current_step.payload.rescheduled) {
      this.has_error = true;
    }
  }

  private showGoToSiteOnHeader() {
    store.dispatch('layout/toggleGoToSiteOnHeader', true);
  }

  unserializeToken = () => {
    const token = sessionStorage.getItem('authorization');
    if (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const json = JSON.parse(window.atob(base64));
      if (json && (json
        .is_logged_in_by_customer !== undefined && json.is_logged_in_by_customer !== true)) {
        this.is_logged_as_promoter = true;
      }
    }
  }

  redirectToBackofficeModule = async () => {
    try {
      await this.logout_command.execute();
      sessionStorage.clear();
      window.location.assign(this.BACKOFFICE_CUSTOMER_TRACKING);
    } catch {
      this.notifier.showErrorNotification('Ha ocurrido un error durante la redirección al módulo de seguimiento de clientes, favor de recargar la página');
    }
  }
}
